export * from './work-flow-add-edit.component';
export * from './work-flow-configuration.component';

export * from './work-flow-configuration-view.component';

export * from './work-flow-configuration-routing.module';

// export * from './requisition-configuration-view.component';
// export * from './requisition-configuration-add-edit.component';
